import Vue from 'vue';
import axios from 'axios';
import { isClerkOrPlayer, getTokenFromLocalStorage, doLogout } from '@/store/modules/player';
import store from '@/store';
import i18n from './i18n';
import { LS_CLIENT_TYPE } from '@/utils/consts';
import snq from 'snq';
import { isElectronContext } from './isElectron';

const isElectron = isElectronContext();

export function getStoreSettings() {
  return store.state.settings;
}

export const _api = axios.create();
_api.defaults.baseURL = process.env.VUE_APP_ROOT_URL;

const setLoading = ({ httpUrl, isLoading }) => {
  let url = snq(() => httpUrl.split('/api')[1]);
  httpUrl = httpUrl.replace('/api', '');
  httpUrl = httpUrl.replace('/api', '');

  if (!url && httpUrl.includes('getlanguagecache')) {
    url = '/common/getlanguagecache';
  }
  if (!url && httpUrl.includes('cms-request/v1/get-options')) {
    url = '/cms-request/v1/get-options';
  }

  url = snq(() => url.replace(/\?.*$/g, ''));
  if (!url) {
    return;
  }

  if (process.env.NODE_ENV === 'development') {
    console.log(`[LOADER] ${url} --> [${isLoading}]`);
  }
  store.commit(
    'helper/setLoading',
    {
      httpUrl: url,
      isLoading,
    },
    {
      root: true,
    },
  );
};

_api.interceptors.request.use(
  function(config) {
    const urll =
      process.env.NODE_ENV !== 'development'
        ? config.url
        : config.url.includes('http')
        ? config.url
        : process.env.VUE_APP_ROOT_URL + config.url;

    const _locale = i18n.locale;
    let localeID = '';
    switch (_locale) {
      case 'en':
        localeID = 0;
        break;
      case 'es':
        localeID = 1;
        break;
      case 'pt':
        localeID = 6;
        break;
      default:
        localeID = 0;
    }
    let sessionId = null;
    let clientType = localStorage.getItem(LS_CLIENT_TYPE);
    config.headers.common['LanguageId'] = localeID;
    config.headers.common['ClientType'] = clientType;

    if (sessionId !== null) {
      // config.headers.common['SessionId'] = sessionId;
    }

    if (config.url.includes('/login')) {
      delete config.headers.common['SessionId'];
    }

    const bearerToken = getTokenFromLocalStorage();

    if (bearerToken) {
      config.headers.common['Authorization'] = 'Bearer ' + getTokenFromLocalStorage();
    } else {
      delete config.headers.common['Authorization'];
    }

    const token = localStorage.getItem('epos_token');
    if (token && !config.url.includes('/wp-json/')) {
      config.headers.common['epos-token'] = token;
    }
    if (config.url.includes('/wp-json')) {
      config.headers.common['Authorization'] = null;
      delete config.headers.common['LanguageId'];
      delete config.headers.common['SessionId'];
      delete config.headers.common['ClientType'];
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  },
);

const toasterExcludeEndpoints = ['/communication/satisfaction-survey/'];

_api.interceptors.response.use(
  function(response) {
    const urll =
      process.env.NODE_ENV !== 'development'
        ? response.config.url
        : response.config.url.includes('http')
        ? response.config.url
        : process.env.VUE_APP_ROOT_URL + response.config.url;

    const screenTime = response.headers['x-screentime'];
    if (screenTime) {
      store.dispatch('settings/setTimeSpent', screenTime);
    }

    if (!response.data.IsSuccess && response.status !== 200) {
      response.data.ExceptionMessage.map(i => {
        if (!!i) {
          console.log({
            url: response.config.url,
            error_message: i,
          });
          Vue.toasted.show(i18n.t('Exceptions.' + i), {
            type: 'error',
            position: 'bottom-center',
            duration: 5000,
          });
        }
      });
    }
    return response;
  },
  async function(error) {
    if (!!error && !!error.response && error.response.status === 424) {
      setTimeout(function() {
        window.location.reload(true);
      }, 1000);
      return;
    }

    if (error && error.response && error.response.status === 401) {
      console.log('401 came, in logout process...');
      // TODO: make this operation only once
      let res = await doLogout();
    } else {
      if (toasterExcludeEndpoints.some(endpoint => !error.response.config.url.includes(endpoint))) {
        Vue.toasted.show(error.message, {
          type: 'error',
          position: 'bottom-center',
          duration: 5000,
        });
      }
    }
    return Promise.reject(error);
  },
);

Vue.prototype.$api = _api;

export const setDefaults = function() {
  const token = localStorage.getItem('epos_token');
  if (token && !isElectron) {
    _api.defaults.headers.common['epos-token'] = token;
  }
  _api.defaults.headers.common['Authorization'] = 'Bearer ' + getTokenFromLocalStorage();
};
setDefaults();
